import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { BrandName } from './BrandName';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-sum-light" data-id="element-114">
      <div className="absolute inset-0 z-0 opacity-10" data-id="element-115">
        <div className="absolute top-0 -left-4 w-72 h-72 bg-sum-green rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob" data-id="element-116"></div>
        <div className="absolute top-0 -right-4 w-72 h-72 bg-sum-gold rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000" data-id="element-117"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-sum-green rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000" data-id="element-118"></div>
      </div>

      {/* Faded background logo */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none" data-id="element-119">
        <img src="https://cdn.magicpatterns.com/uploads/6cUEwm9nWDESrDmpRk3ub3/sum_logo.jpg" alt="" className="w-[600px] md:w-[900px] lg:w-[1100px] h-auto opacity-[0.12] select-none scale-x-125" data-id="element-120" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-121">
        <div className="text-center max-w-4xl mx-auto" data-id="element-122">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-123">
            <div className="relative mx-auto mb-8 -mt-28 md:-mt-44 h-44 md:h-56 w-44 md:w-56 rounded-full flex items-center justify-center" style={{
            background: 'radial-gradient(circle, white 40%, #f0fdf4 80%, transparent 100%)'
          }} data-id="element-124">
              <img src="https://cdn.magicpatterns.com/uploads/2VZ8jBbDo4pgNKGHKfVb1h/logo_sum_marketing.png" alt="SalesUp Marketing" className="h-32 md:h-44 w-auto rounded-full object-contain" data-id="element-125" />
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-sum-charcoal tracking-tight mb-6 leading-tight" data-id="element-126">
              Get More Customers with{' '}
              <span className="text-sum-green" data-id="element-127">Smart Websites</span> and Social
              Media
            </h1>
          </motion.div>

          <motion.p className="mt-4 text-xl md:text-2xl text-gray-600 mb-8 font-medium" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-128">
            Expert Web Development, Social Media Management & SEO to Boost Your
            Business Online.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-10" data-id="element-129">
            <a href="#contact" className="w-full sm:w-auto flex items-center justify-center px-8 py-4 text-lg font-bold rounded-lg text-white bg-sum-green hover:bg-green-700 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-130">
              Get a Free Consultation
              <ArrowRight className="ml-2" size={20} data-id="element-131" />
            </a>
          </motion.div>

          <motion.div className="flex flex-col sm:flex-row justify-center items-center gap-6 text-sm text-gray-500 font-medium" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-132">
            <div className="flex items-center" data-id="element-133">
              <CheckCircle2 className="text-sum-green mr-2" size={20} data-id="element-134" />
              <span data-id="element-135">We use smart keywords to get you found on Google</span>
            </div>
            <div className="flex items-center" data-id="element-136">
              <CheckCircle2 className="text-sum-green mr-2" size={20} data-id="element-137" />
              <span data-id="element-138">8 Years Experience</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}